import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Box from '@mui/material/Box';
import LensIcon from '@mui/icons-material/Lens';
import { green } from '@mui/material/colors';

import { getConfigChargerContact } from 'utils/clientHelper';

const styles = theme => ({
    root: {
        margin: 0,
        padding: 0
    },
    link: theme.style.link,
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },
    actionContainer: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row-reverse',
        marginBottom: theme.spacing(3)
    },
    buttonControl: {
        margin: '8px 0px 8px 16px'
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },
    marginLeft: {
        marginLeft: '15px'
    }
});

class AdministrationClient extends React.Component {
    render() {
        let { classes, client, isPatching, onClickSave, onChange } = this.props;

        if (!client) {
            return null;
        }

        return (
            <React.Fragment>
                <div className={classes.root}>
                    <Helmet>
                        <title>{`Client : ${client.code}`}</title>
                    </Helmet>

                    <Typography gutterBottom variant="h5">
                        Édition du client : {client.code} - {client.libelle}
                    </Typography>

                    <Breadcrumbs separator="›" arial-label="breadcrumb">
                        <Link to={`/administration/clients/`} className={classes.link}>
                            <Typography variant="button">
                                Clients
                            </Typography>
                        </Link>

                        <Typography color="textPrimary">{client.code} - {client.libelle}</Typography>
                    </Breadcrumbs>

                    <Paper className={classes.paper}>
                        <Typography gutterBottom variant="h6">
                            Paramètres
                        </Typography>

                        <FormControlLabel
                            control={
                                <Switch
                                    id="prioritaire"
                                    name="prioritaire"
                                    checked={client.prioritaire}
                                    onChange={onChange}
                                    value="Prioritaire"
                                    color="secondary"
                                />
                            }
                            label="Prioritaire : "
                            labelPlacement="start"
                        />

                        <FormControlLabel
                            control={
                                <Switch
                                    id="autoriseNotificationSouffranceTransporteur"
                                    name="autoriseNotificationSouffranceTransporteur"
                                    checked={client.autoriseNotificationSouffranceTransporteur}
                                    onChange={onChange}
                                    value="AutoriseNotificationSouffranceTransporteur"
                                    color="secondary"
                                />
                            }
                            label="Autorise notification souffrance transporteur : "
                            labelPlacement="start"
                        />

                        <TextField
                            className={classes.marginLeft}
                            name='pctJokerFraisRetour'
                            label="Avoir joker"
                            value={client.pctJokerFraisRetour}
                            onChange={onChange}
                        />

                        <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, ml: '15px' }}>
                            <Typography variant="body1" sx={{ mr: 1 }}>
                                Chargement des contacts :
                            </Typography>
                            {(() => {
                                const config = getConfigChargerContact(client.chargerContactExclusionMotif);
                                return (
                                    <>
                                        <LensIcon sx={{ color: config.color, fontSize: '1.2rem', mr: 1 }} />
                                        <Typography variant="body2" color="textSecondary">
                                            {config.message}
                                        </Typography>
                                    </>
                                );
                            })()}
                        </Box>
                    </Paper>

                    <div className={classes.actionContainer} >
                        <Link to="/administration/clients">
                            <Button
                                className={classes.buttonControl}
                                disabled={false}
                                onClick={onClickSave}
                                variant="contained"
                                color="secondary"
                            >
                                Enregistrer
                                    {isPatching === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </Button>
                        </Link>
                        <Link to="/administration/clients">
                            <Button className={classes.buttonControl} color="primary" >
                                Annuler
                            </Button>
                        </Link>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

AdministrationClient.propTypes = {
    classes: PropTypes.object.isRequired,
    client: PropTypes.object
};

export default withStyles(styles)(AdministrationClient);